import { createStyles, makeStyles } from '@material-ui/styles';
import { Loader as NDSLoader } from 'neon-design-system';

const useStyles = makeStyles(() =>
  createStyles({
    loader: {
      position: 'relative',
      transform: 'translate(-50%, -50%)',
      left: '50%',
      top: '50%'
    },
    fixedHeight: {
      minHeight: '50vh'
    }
  })
);

interface Props {
  fixedHeight?: boolean;
}

export const Loader = (props: Props) => {
  const classes = useStyles();

  return (
    <div className={[classes.loader, props.fixedHeight && classes.fixedHeight].filter(Boolean).join(' ')}>
      <NDSLoader />
    </div>
  );
};
